import Vue from 'vue'
import VueRouter from 'vue-router'
import route from '../store/index'
import api from '../api/index'
Vue.use(VueRouter)
const routes = [
  {
    path: '/',
    name: 'Layout',
    component: () => import('../layout.vue'),
    redirect: { name: 'index' },
    children: [
      {
        path: "/index",
        name: "index",
        component: () => import('../views/index/index.vue')
      },
      {
        path: "/blank",
        name: "blank",
        component: () => import('../views/index/blank.vue')
      },
      {
        path: "/board/money",
        name: "board_money",
        meta: { bread: ["积分统计", "数据看板"] },
        component: () => import('../views//board/money.vue')
      },
      {
        path: "/account/power",
        name: "account_power",
        meta: { bread: ["账户管理", "后台用户"] },
        component: () => import("../views/account/power.vue")
      },
      {
        path: "/account/imComplain",
        name: "imComplain",
        meta: { bread: ["账户管理", "艾信用户投诉"] },
        component: () => import("../views/account/imComplain")
      },
      {
        path: "/account/imTeamComplain",
        name: "imTeamComplain",
        meta: { bread: ["账户管理", "艾信群投诉"] },
        component: () => import("../views/account/imTeamComplain")
      },
      {
        path: "/account/app",
        name: "account_app",
        meta: { bread: ["账户管理", "app用户"] },
        component: () => import("../views/account/appUser.vue")
      }, {
        path: "/account/privacyUser",
        name: "privacyUser",
        meta: { bread: ["账户管理", "私域平台用户列表"] },
        component: () => import("../views/account/privacyUser.vue")
      },
      {
        path: "/account/record",
        name: "account_record",
        meta: { bread: ["账户管理", "推广记录"] },
        component: () => import("../views/account/record.vue")
      },
      {
        path: "/production/productList/:id?",
        name: "production_product_list",
        meta: { bread: ["商品管理", "商品列表"] },
        component: () => import("../views/production/productList.vue")
      },
      {
        path: "/production/selection",
        name: "production_selection",
        meta: { bread: ["商品管理", "商户选品列表"] },
        component: () => import("../views/production/selection.vue")
      },
      {
        path: "/production/merchantSelection",
        name: "production_merchant_selection",
        meta: { bread: ["商品管理", "商户选品列表"] },
        component: () => import("../views/production/merchantSelection.vue")
      },
      {
        path: "/production/comment",
        name: "production_comment",
        meta: { bread: ["商品管理", "商品列表", "商品评论"] },
        component: () => import("../components/productMomment.vue")
      },
      {
        path: "/production/productListDialog",
        name: "production_productListDialog",
        meta: { bread: ["商品管理", "商品列表", "商品添加"] },
        component: () => import("../views/production/productListDialog.vue")
      },
      {
        path: "/production/productType",
        name: "production_productType",
        meta: { bread: ["商品管理", "商品类型"] },
        component: () => import("../views/production/productType.vue")
      },
      {
        path: "/marketing/serve",
        name: "marketing_serve",
        meta: { bread: ["营销管理", "更多服务"] },
        component: () => import("../views/marketing/serve.vue")
      },
      {
        path: "/marketing/activity",
        name: "marketing_activity",
        meta: { bread: ["营销管理", "活动列表"] },
        component: () => import("../views/marketing/activity.vue")
      },
      {
        path: "/marketing/activityDetali",
        name: "marketing_activity_detali",
        meta: { bread: ["营销管理", "活动列表", "活动列表新增"] },
        component: () => import("../components/activityDialog.vue")
      },
      {
        path: "/marketing/coupon",
        name: "marketing_coupon",
        meta: { bread: ["营销管理", "优惠券列表"] },
        component: () => import("../views/marketing/coupon.vue")
      },
      {
        path: "/marketing/couponActivity",
        name: "marketing_couponActivity",
        meta: { bread: ["营销管理", "优惠券活动"] },
        component: () => import("../views/marketing/couponActivity.vue")
      },
      {
        path: "/marketing/activityCoupon",
        name: "marketing_activityCoupon",
        meta: { bread: ["营销管理", "平台优惠券列表"] },
        component: () => import("../views/marketing/activityCoupon.vue")
      },
      {
        path: "/marketing/papckage",
        name: "marketing_papckage",
        meta: { bread: ["营销管理", "套餐列表"] },
        component: () => import("../views/marketing/papckage.vue")
      },
      {
        path: "/marketing/integral",
        name: "marketing_integral",
        meta: { bread: ["营销管理", "积分活动"] },
        component: () => import("../views/marketing/integral.vue")
      },
      {
        path: "/marketing/integralMall",
        name: "marketing_integral_mall",
        meta: { bread: ["营销管理", "积分商城"] },
        component: () => import("../views/marketing/integralMall.vue")
      },
      {
        path: "/marketing/serveMall",
        name: "marketing_serve_mall",
        meta: { bread: ["营销管理", "服务商城"] },
        component: () => import("../views/marketing/serveMall.vue")
      },
      {
        path: "/marketing/integralDetail",
        name: "marketing_integral_detail",
        meta: { bread: ["营销管理", "积分活动", "积分详情"] },
        component: () => import("../components/integralDetails.vue")
      },
      {
        path: "/marketing/freightTemplate",
        name: "marketing_freightTemplate",
        meta: { bread: ["营销管理", "运费模版"] },
        component: () => import("../views/marketing/freightTemplate/index.vue")
      },
      {
        path: "/orderManagement/serveOrder",
        name: "order_management_serve_order",
        meta: { bread: ["订单管理", "服务订单"] },
        component: () => import("../views/orderManagement/serveOrder.vue")
      },
      {
        path: "/orderManagement/productOrder",
        name: "order_management_product_order",
        meta: { bread: ["订单管理", "商品订单"] },
        component: () => import("../views/orderManagement/productOrder.vue")
      },
      {
        path: "/orderManagement/papckageOrder",
        name: "order_management_papckage_order",
        meta: { bread: ["订单管理", "套餐订单"] },
        component: () => import("../views/orderManagement/papckageOrder.vue")
      },
      {
        path: "/orderManagement/productOrderDetail",
        name: "order_management_product_order_detail",
        meta: { bread: ["订单管理", "商品订单", "详情"] },
        component: () => import("../components/productOrderDetail.vue")
      },
      {
        path: "/orderManagement/deliverGoods",
        name: "order_management_deliver_goods",
        meta: { bread: ["订单管理", "发货列表"] },
        component: () => import("../views/orderManagement/deliverGoods.vue")
      },
      {
        path: "/orderManagement/afterSale",
        name: "order_management_after_sale",
        meta: { bread: ["订单管理", "商品售后列表"] },
        component: () => import("../views/orderManagement/afterSale.vue")
      },
      {
        path: "/orderManagement/userAppeal",
        name: "order_management_user_appeal",
        meta: { bread: ["订单管理", "商品售后列表",'用户申诉'] },
        component: () => import("../views/orderManagement/userAppeal.vue")
      },
      {
        path: "/businessShare/index",
        name: "business_share_index",
        meta: { bread: ["订单管理", "创业平台订单列表"] },
        component: () => import("../views/businessShare/index.vue")
      },
      {
        path: "/serviceOrder/serviceOrder",
        name: "serviceorder_serviceorder",
        meta: { bread: ["订单管理", "创业平台服务订单列表"] },
        component: () => import("../views/serviceOrder/serviceOrder.vue")
      },
      {
        path: "/orderManagement/serveSale",
        name: "order_management_serve_sale",
        meta: { bread: ["订单管理", "服务售后列表"] },
        component: () => import("../views/orderManagement/serveSale.vue")
      },
      {
        path: "/orderManagement/yiQishunOrder",
        name: "order_management_yi_qishun_order",
        meta: { bread: ["订单管理", "易企顺商品订单列表"] },
        component: () => import("../views/orderManagement/yiQishunOrder.vue")
      },
      {
        path: "/blindBoxManagement/wineManage",
        name: "blind_box_management_wine_Manage",
        meta: { bread: ["盲盒管理", "酒水盲盒管理"] },
        component: () => import("../views/blindBoxManagement/wineManage.vue")
      },
      {
        path: "/blindBoxManagement/blindList",
        name: "blind_box_management_blind_list",
        meta: { bread: ["盲盒管理", "酒水盲盒产品列表"] },
        component: () => import("../views/blindBoxManagement/blindList.vue")
      },
      {
        path: "/blindBoxManagement/wineBlind",
        name: "blind_box_management_wine_blind",
        meta: { bread: ["盲盒管理", "酒水盲盒订单管理"] },
        component: () => import("../views/blindBoxManagement/wineBlind.vue")
      },
      {
        path: "/blindBoxManagement/deliver",
        name: "blind_box_management_deliver",
        meta: { bread: ["盲盒管理", "盲盒发货列表"] },
        component: () => import("../views/blindBoxManagement/deliver.vue")
      },
      {
        path: "/blindBoxManagement/assistList",
        name: "blind_box_management_assist_list",
        meta: { bread: ["盲盒管理", "邀请列表"] },
        component: () => import("../views/blindBoxManagement/assistList.vue")
      },
      {
        path: "/blindBoxManagement/couponList",
        name: "blind_box_management_coupon_list",
        meta: { bread: ["盲盒管理", "盲盒券列表"] },
        component: () => import("../views/blindBoxManagement/couponList.vue")
      },
      {
        path: "/blindBoxManagement/dictumList",
        name: "blind_box_management_dictum_list",
        meta: { bread: ["盲盒管理", "酒后人生名言"] },
        component: () => import("../views/blindBoxManagement/dictumList.vue")
      },
      {
        path: "/merchant/businessListings",
        name: "merchant_business_listings",
        meta: { bread: ["商户管理", "商户列表"] },
        component: () => import("../views/Merchant/businessListings.vue")
      },
      {
        path: "/merchant/contractor",
        name: "merchant_contractor",
        meta: { bread: ["商户管理", "承包商户列表"] },
        component: () => import("../views/Merchant/contractor.vue")
      },
      {
        path: "/merchant/comment",
        name: "merchant_comment",
        meta: { bread: ["商户管理", "商户列表", "评论"] },
        component: () => import("../components/merchantMomment.vue")
      },
      {
        path: "/merchant/merchantServices",
        name: "merchant_merchant_services",
        meta: { bread: ["商户管理", "商户服务类型"] },
        component: () => import("../views/Merchant/merchantServices.vue")
      },
      {
        path: "/merchant/serveContent",
        name: "merchant_serve_content",
        meta: { bread: ["商户管理", "服务类型列表"] },
        component: () => import("../views/Merchant/serveContent.vue")
      },
      {
        path: "/merchant/applicationService",
        name: "merchant_application_service",
        meta: { bread: ["商户管理", "申请服务列表"] },
        component: () => import("../views/Merchant/applicationService.vue")
      },
      {
        path: "/merchant/caseList",
        name: "merchant_case_list",
        meta: { bread: ["商户管理", "案例列表"] },
        component: () => import("../views/Merchant/caseList.vue")
      },
      {
        path: "/merchant/recruitList",
        name: "merchant_recruit_list",
        meta: { bread: ["商户管理", "招聘列表"] },
        component: () => import("../views/Merchant/recruitList.vue")
      },
      {
        path: "/merchant/recruitMessage",
        name: "merchant_recruit_message",
        meta: { bread: ["商户管理", "招聘列表", "留言列表"] },
        component: () => import("../components/recruitListMessage.vue")
      },
      {
        path: "/merchant/serviceRefund",
        name: "merchant_service_refund",
        meta: { bread: ["商户管理", "服务退款申诉"] },
        component: () => import("../views/Merchant/serviceRefund.vue")
      },
      {
        path: "/merchantProductList/merchantProductList",
        name: "merchant_product_list_merchant_product_list",
        meta: { bread: ["商户管理", "商户商品列表"] },
        component: () => import("../views/merchantProductList/merchantProductList.vue")
      },
      {
        path: "/task/taskInfo",
        name: "task_info",
        meta: { bread: ["任务中心管理", "任务信息列表"] },
        component: () => import("../views/task/taskInfo.vue")
      },
      {
        path: "/task/examineInfo",
        name: "examine_info",
        meta: { bread: ["任务中心管理", "审核信息列表"] },
        component: () => import("../views/task/examineInfo.vue")
      },
      {
        path: "/operate/channel",
        name: "operate_channel",
        meta: { bread: ["运营管理", "渠道管理"] },
        component: () => import("../views/operate/channel.vue")
      },
      {
        path: "/operate/bannerImg",
        name: "operate_banner_img",
        meta: { bread: ["运营管理", "banner图"] },
        component: () => import("../views/operate/bannerImg.vue")
      },
      {
        path: "/operate/shareImg",
        name: "operate_share_img",
        meta: { bread: ["运营管理", "分享图"] },
        component: () => import("../views/operate/shareImg.vue")
      },
      {
        path: "/operate/useHelp",
        name: "operate_use_Help",
        meta: { bread: ["运营管理", "使用帮助"] },
        component: () => import("../views/operate/useHelp.vue")
      },
      {
        path: "/operate/system",
        name: "operate_system",
        meta: { bread: ["运营管理", "系统公告"] },
        component: () => import("../views/operate/system.vue")
      },
      {
        path: "/operate/feedback",
        name: "operate_feedback",
        meta: { bread: ["运营管理", "反馈列表"] },
        component: () => import("../views/operate/feedback.vue")
      },
      {
        path: "/operate/broadcast",
        name: "operate_broadcast",
        meta: { bread: ["运营管理", "广播列表"] },
        component: () => import("../views/operate/broadcast.vue")
      },
      {
        path: "/operate/article",
        name: "operate_article",
        meta: { bread: ["运营管理", "内容管理"] },
        component: () => import("../views/operate/article/index.vue")
      },
      {
        path: "/operate/article/info",
        name: "operate_article_info",
        meta: { bread: ["运营管理", "内容管理"] },
        component: () => import("../views/operate/article/info.vue")
      },
      {
        path: "/operate/imBroadcast",
        name: "operate_imBroadcast",
        meta: { bread: ["运营管理", "艾信通广播"] },
        component: () => import("../views/operate/imBroadcast/index.vue")
      },
      {
        path: "/operate/backstage",
        name: "operate_backstage",
        meta: { bread: ["运营管理", "后台站内信"] },
        component: () => import("../views/operate/backstage.vue")
      },
      {
        path: "/operate/SMSmessage",
        name: "operate_SMSmessage",
        meta: { bread: ["运营管理", "短信消息模板"] },
        component: () => import("../views/operate/SMSmessage.vue")
      },
      {
        path: "/finance/withdrawal",
        name: "finance_withdrawal",
        meta: { bread: ["财务管理", "提现列表"] },
        component: () => import("../views/finance/withdrawal.vue")
      },
      {
        path: "/setting/password",
        name: "setting_password",
        meta: { bread: ["设置管理", "我的设置", "密码修改"] },
        component: () => import("../views/setting/password.vue")
      },
      {
        path: "/setting/routeManagement",
        name: "setting_route_management",
        meta: { bread: ["设置管理", "页面管理"] },
        component: () => import("../views/setting/routeManagement.vue")
      },
      {
        path: "/setting/basicInformation",
        name: "setting_basic_information",
        meta: { bread: ["设置管理", "我的设置", "基本资料"] },
        component: () => import("../views/setting/basicInformation.vue")
      },
      {
        path: "/setting/siteSettings",
        name: "setting_site_settings",
        meta: { bread: ["设置管理", "系统设置", "网站设置"] },
        component: () => import("../views/setting/siteSettings.vue")
      },
      {
        path: "/setting/withdrawalRiskControl",
        name: "setting_withdrawal_risk_control",
        meta: { bread: ["设置管理", "系统设置", "提现风控"] },
        component: () => import("../views/setting/withdrawalRiskControl.vue")
      },
      {
        path: "/setting/menberSettings",
        name: "setting_menber_settings",
        meta: { bread: ["设置管理", "系统设置", "会员设置"] },
        component: () => import("../views/setting/menberSettings.vue")
      },
      {
        path: "/setting/all",
        name: "setting_all",
        meta: { bread: ["设置管理", "角色管理"] },
        component: () => import("../views/setting/all.vue")
      },
      {
        path: "/classification/productType",
        name: "product_type",
        meta: { bread: ["分类管理", "商品分类"] },
        component: () => import("../views/classification/productType.vue")
      },
      {
        path: "/classification/selectionType",
        name: "selection_type",
        meta: { bread: ["分类管理", "商户选品分类"] },
        component: () => import("../views/classification/selectionType.vue")
      },
      {
        path: "/classification/serve",
        name: "serve",
        meta: { bread: ["分类管理", "服务类型"] },
        component: () => import("../views/classification/serve.vue")
      },
      // {
      //   path:"/classification/merchantServices",
      //   name:"merchant_services",
      //   meta:{bread:["分类管理","商户服务列表"]},
      //   component:()=>import("../views/classification/merchantServices.vue")
      // },
      {
        path: "/classification/platform",
        name: "platform",
        meta: { bread: ["分类管理", "第三方服务列表"] },
        component: () => import("../views/classification/platform.vue")
      },
      {
        path: "/supplyChain/yiQishun",
        name: "yi_qishun",
        meta: { bread: ["供应链管理", "易企顺商品列表"] },
        component: () => import("../views/supplyChain/yiQishun.vue")
      },
      {
        path: "/supplyChain/shengTian",
        name: "sheng_tian",
        meta: { bread: ["供应链管理", "胜天半子列表"] },
        component: () => import("../views/supplyChain/shengTian.vue")
      },
      {
        path: "/PlatformPartner/partnerorder",
        name: "partnerOrder_List",
        meta: { bread: ["平台合伙人", "合伙人订单信息列表"] },
        component: () => import("../views/PlatformPartner/partnerorder.vue")
      },
      {
        path: "/PlatformPartner/partnerList",
        name: "partner_List",
        meta: { bread: ["平台合伙人", "合伙人信息列表"] },
        component: () => import("../views/PlatformPartner/partnerList.vue")
      },
      // {
      //   path: "/orderManagement/productOrderDetail",
      //   name: "order_management_product_order_detail",
      //   meta: { bread: ["订单管理", "商品订单", "详情"] },
      //   component: () => import("../components/productOrderDetail.vue")
      // },
      {
        path: "/PlatformPartner/partner",
        name: "partner",
        meta: { bread: ["平台合伙人", "合伙人订单信息列表", "合作伙伴"] },
        component: () => import("../components/partner.vue")
      },
      // {
      //   path:"/PlatformPartner/partnerorder.vue",
      //   name:"partnerOrder_List",
      //   meta:{bread:["平台合伙人","合伙人订单信息列表"]},
      //   component:()=>import("../views/PlatformPartner/partnerorder.vue")
      // },
      // {
      //   path:"/supplyChainOrder/yiQishunOrder",
      //   name:"yi_qishun_order",
      //   meta:{bread:["供应链订单管理","易企顺商品订单列表"]},
      //   component:()=>import("../views/supplyChainOrder/yiQishunOrder.vue")
      // },
      {
        path: "/activityArea/activityArea",
        name: "activity_area",
        meta: { bread: ["活动专区", "活动板块"] },
        component: () => import("../views/activityArea/activityArea.vue")
      },
      {
        path: "/activityArea/activityProductList",
        name: "activity_product_list",
        meta: { bread: ["活动专区", "活动商品列表"] },
        component: () => import("../views/activityArea/activityProductList.vue")
      },
      {
        path: "/apply/applyList",
        name: "apply_list",
        meta: { bread: ["邀请函", "参加人员列表"] },
        component: () => import("../views/apply/applyList.vue")
      },
      {
        path: "/apply/applyActivityList",
        name: "apply_activity_list",
        meta: { bread: ["邀请函", "活动列表"] },
        component: () => import("../views/apply/applyActivityList.vue")
      },

      {
        path: "/PlatformPartner/partnerStatistics",
        name: "partnerStatistics",
        meta: { bread: ["合伙人统计", "合伙人统计列表"] },
        component: () => import("../views/PlatformPartner/partnerStatistics.vue")
      },
    ]
  },
  {
    path: '/Login',
    name: 'Login',
    component: () => import('../login.vue')
  },
]

const router = new VueRouter({
  routes
})
// 路由拦截
router.beforeEach((to, from, next) => {
  let arr = JSON.parse(localStorage.getItem('routeList'))
  let routeID = localStorage.getItem('rouId')
  let page = to.path.split('/')
  let toPage = page[2] == 'productList' ? '/production/productList' : to.path
  let a = []
  if (arr) {
    arr.forEach(e => {
      if (!e.menuInfoList) return
      a.push(e.menuInfoList.some(obj => {
        // 存在路由时存储按钮
        if (obj.jump === toPage) {
          api.account.adminJurisdiction().then(res => {
            let data = res.data.data
            data.forEach(child => {
              if (Number(child.id) === Number(routeID)) {
                if (obj.menuInfoList) {
                  let childData = child.roule.split(',')
                  let control = []
                  obj.menuInfoList.forEach(son => {
                    childData.forEach(sonCd => {
                      if (Number(sonCd) === son.id) {
                        control.push(son.jump)
                      }
                    })
                  })
                  route.commit('savePageButton', control)
                }
              }
            })
          })
        }
        return obj.jump === toPage
      }))
    })
  }
  if (
    a.includes(true) || ['/index', '/Login', '/blank', '/production/productListDialog', '/operate/article/info','/PlatformPartner/partner', '/orderManagement/productOrderDetail','/orderManagement/userAppeal'].includes(toPage)
  ) {
    next()
  } else {
    next({ path: '/' })
  }
})
export default router




// WEBPACK FOOTER //
// ./src/router/index.js